(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparrow-brand-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-labhya-style-finder]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const choices = [...section.querySelectorAll('[data-labhya-edit-choice]')];
      const reveal = section.querySelector('[data-labhya-edit-reveal]');
      const kicker = section.querySelector('[data-labhya-edit-kicker]');
      const title = section.querySelector('[data-labhya-edit-title]');
      const copy = section.querySelector('[data-labhya-edit-copy]');
      const link = section.querySelector('[data-labhya-edit-link]');
      const surprise = section.querySelector('[data-labhya-edit-surprise]');

      const showChoice = (choice) => {
        if (!choice) return;
        choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
        if (kicker) kicker.textContent = 'YOUR LABHYA EDIT';
        if (title) title.textContent = choice.dataset.title || '';
        if (copy) copy.textContent = choice.dataset.copy || '';
        if (reveal) reveal.dataset.accent = choice.dataset.accent || 'mystery';
        if (link) {
          link.href = choice.dataset.href || '#';
          link.innerHTML = `${choice.dataset.linkLabel || 'Explore this edit'} <span aria-hidden="true">→</span>`;
          link.hidden = false;
        }
      };

      choices.forEach((choice) => choice.addEventListener('click', () => showChoice(choice)));
      surprise?.addEventListener('click', () => {
        const choice = choices[Math.floor(Math.random() * choices.length)];
        showChoice(choice);
        reveal?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
